import { DayWithoutTotal } from '../../../+authenticated/+schedule/shared/schedule.interfaces';
import { OpenShiftModel } from '../../../reducers/orm/open-shift/open-shift.model';
import { ObjectMap } from '../../../reducers/orm/orm.interfaces';
import { RequiredShiftModel } from '../../../reducers/orm/required-shift/required-shift.model';
import { ScheduleModel } from '../../../reducers/orm/schedule/schedule.model';
import { PayloadKeyType } from '../../../reducers/shared/entity.helper';
import {
  AggregatedEntityData,
  calculateSingleItemRowHeight,
  update,
} from '../../../reducers/store/schedule-shared.helper';
import { TeamDataNModel } from '../../../reducers/store/teamdata/team-data.n.model';

interface TeamSourceData {
  schedules: ScheduleModel[];
  openShifts: OpenShiftModel[];
  requiredShifts: RequiredShiftModel[];
}

export const groupTeamData = (data: TeamSourceData, totals: DayWithoutTotal[]) => {
  let teams: ObjectMap<AggregatedEntityData> = {};

  teams = update(teams, data.schedules, PayloadKeyType.SCHEDULES, 'occurrence_id', 'team_id');
  teams = update(teams, data.openShifts, PayloadKeyType.OPENSHIFTS, 'occurrence_id', 'team_id');
  teams = update(teams, data.requiredShifts, PayloadKeyType.REQUIRED_SHIFTS, 'occurrence_id', 'team_id');

  // Entities without a team are grouped under the stringified `null` team id; they belong to no
  // team row, so that bucket is dropped rather than rendered.
  delete teams['null'];

  const teamData: TeamDataNModel[] = Object.values(teams).map((team) => ({
    ...team,
    // Seeded empty: the team-data reducer fills these in when it reprocesses the upserted state.
    filteredSchedules: [],
    filteredOpenShifts: [],
    filteredRequiredShifts: [],
    openShiftsRowHeight: calculateSingleItemRowHeight(team.openShifts, totals),
    requiredShiftsRowHeight: calculateSingleItemRowHeight(team.requiredShifts, totals),
  }));

  return Object.values(teamData);
};

export const createNewModel = (groupById: string) => ({
  id: groupById,
  requiredShifts: {},
  openShifts: {},
  teamDays: {},
  schedules: {},
});
